export default __webpack_public_path__ + "static/media/main-characters-end-md-1x.a9d67520.jpg";